import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

function useDevicesTypeView() {

  const { t } = useTranslation();

  const isEditDefault = useSelector(({ modbusMaps }) => modbusMaps.isEditDefault);
  const createEditValues = useSelector(({ modbusMaps }) => modbusMaps?.createEditValues);

  const deviceType = useSelector(({ modbusMaps }) => modbusMaps?.createEditValues);

  const [loading, setLoading] = useState(true);
  const [dataSource, setDataSource] = useState([]);

  const getValFun = (id) => {

    let valueString = '';

    switch (id) {

      case '1':
        valueString = 'Read coils or digital outputs';
        break;
      case '2':
        valueString = 'Read digital inputs';
        break;
      case '3':
        valueString = 'Read registers or analog outputs';
        break;
      case '4':
        valueString = 'Read analog inputs';
        break;
      case '5':
        valueString = 'Write single coil or output';
        break;
      case '6':
        valueString = 'Write single register';
        break;
      case '15':
        valueString = 'Write multiple coils or outputs';
        break;
      case '16':
        valueString = 'Write multiple registers';
        break;
      default:
        valueString = id;
        break;

    }

    return valueString;

  };

  const columns = [
    {
      title: t('views.dynamic_device_types_create_edit.labels.device_type_name_g'),
      dataIndex: 'variable_name',
      key: 'variable_name',
    },
    {
      title: t('views.dynamic_device_types_create_edit.labels.variable_key_g'),
      dataIndex: 'variable_key',
      key: 'variable_key',
    },
    {
      title: t('views.dynamic_device_types_create_edit.labels.variable_descriptor_g'),
      dataIndex: 'variable_descriptor',
      key: 'variable_descriptor',
    },
    {
      title: t('views.dynamic_device_types_create_edit.labels.modbus_name_g'),
      dataIndex: 'modbus_name',
      key: 'modbus_name',
    },
    {
      title: t('views.dynamic_device_types_create_edit.labels.modbus_function_g'),
      dataIndex: 'modbus_function',
      key: 'modbus_function',
      render: (modbus_function) => getValFun(modbus_function) || '',
    },
    {
      title: t('views.dynamic_device_types_create_edit.labels.modbus_direction_g'),
      dataIndex: 'modbus_direction',
      key: 'modbus_direction',
    },
    {
      title: t('views.dynamic_device_types_create_edit.labels.factor_to_multiply_g'),
      dataIndex: 'factor_to_multiply',
      key: 'factor_to_multiply',
    },
    {
      title: t('views.dynamic_device_types_create_edit.labels.modbus_size'),
      dataIndex: 'modbus_size',
      key: 'modbus_size',
    },
    {
      title: t('views.dynamic_device_types_create_edit.labels.datatypes_g'),
      dataIndex: 'datatypes',
      key: 'datatypes',
    },
  ];

  const getData = (objState) => {

    let data = [];
    if (objState?.variables?.length > 0) {

      const newMapsVariables = objState?.variables.map((obj, index) => {

        let itemData;

        const maps = objState?.maps.filter((item) => item.modbus_name === obj.variable_modbus_map);
        if (maps.length > 0) {

          itemData = {
            key: index,
            ...obj,
            ...maps[0],
          };

        } else {

          itemData = {
            key: index,
            ...obj,
          };

        }

        return itemData;

      });

      data = newMapsVariables;

    } else {

      data = [];

    }

    setDataSource(data);

  };

  useEffect(() => {

    getData(createEditValues);
    setLoading(false);

  }, [createEditValues]);

  return {
    loading,
    dataSource,
    columns,
    isEditDefault,
    deviceType,
  };

}

export default useDevicesTypeView;
